import { render, staticRenderFns } from "./CardConfigDrawer.vue?vue&type=template&id=35cf4c89&"
import script from "./CardConfigDrawer.vue?vue&type=script&lang=ts&"
export * from "./CardConfigDrawer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports